import { AudienceSegmentsQuery } from './audience-segments-query';
import { CampaignByIdQuery } from './campaign-by-id-query';
import { CampaignContentsByIdQuery } from './campaign-contents-by-id-query';
import { CampaignSuggestionsMutation } from './campaign-suggestions-mutation';
import { CampaignsQuery } from './campaigns-query';
import { ChangeRecurringCampaignStateMutation } from './change-recurring-state-mutation';
import { ChargeCampaignMutation } from './charge-campaign-mutation';
import { ClientsByChannelQuery } from './clients-by-channel-query';
import { CreateCampaignMutation } from './create-campaign-mutation';
import { CreatePromoCodeMutation } from './create-promo-code-mutation';
import { CustomerGroupsQuery } from './customer-groups-query';
import { DeleteCampaignMutation } from './delete-campaign-mutation';
import { DuplicateCampaignMutation } from './duplicate-campaign-mutation';
import { GenerateCampaignImageMutation } from './generate-campaign-image-mutation';
import { GenerateCampaignTextMutation } from './generate-campaign-text-mutation';
import { PromoCodesQuery } from './promo-codes-query';
import { RefineCampaignTextMutation } from './refine-campaign-text-mutation';
import { SendPreviewMutation } from './send-preview-mutation';
import { UpdateCampaignMutation } from './update-campaign-mutation';
import { CampaignMetadataByIdQuery } from './campaign-metadata-by-id-query';
import { EngagePermissionsMutation } from './engage-permissions-mutation';
import { CampaignCreatorsFilterQuery } from './campaign-creators-filter-query';
export var endpoints = {
    campaignsQuery: new CampaignsQuery(),
    campaignByIdQuery: new CampaignByIdQuery(),
    customerGroupsQuery: new CustomerGroupsQuery(),
    changeRecurringStateMutation: new ChangeRecurringCampaignStateMutation(),
    deleteCampaignMutation: new DeleteCampaignMutation(),
    duplicateCampaignMutation: new DuplicateCampaignMutation(),
    createCampaignMutation: new CreateCampaignMutation(),
    updateCampaignMutation: new UpdateCampaignMutation(),
    createPromoCodeMutation: new CreatePromoCodeMutation(),
    promoCodesQuery: new PromoCodesQuery(),
    clientsByChannelQuery: new ClientsByChannelQuery(),
    audienceSegmentsQuery: new AudienceSegmentsQuery(),
    chargeCampaignMutation: new ChargeCampaignMutation(),
    campaignContentsByIdQuery: new CampaignContentsByIdQuery(),
    campaignMetadataByIdQuery: new CampaignMetadataByIdQuery(),
    sendPreviewMutation: new SendPreviewMutation(),
    generateCampaignTextMutation: new GenerateCampaignTextMutation(),
    refineCampaignTextMutation: new RefineCampaignTextMutation(),
    campaignSuggestionsMutation: new CampaignSuggestionsMutation(),
    generateCampaignImageMutation: new GenerateCampaignImageMutation(),
    engagePermissionsMutation: new EngagePermissionsMutation(),
    campaignCreatorsFilterQuery: new CampaignCreatorsFilterQuery(),
};
